import React from 'react';

import { Box } from 'design/atoms/Box';
import { STFlex } from 'design/atoms/Container';
import { BaseText } from 'design/atoms/Text';
import { STButton } from 'design/atoms/Button';
import { StyledLink } from 'src/shared/StyledLink';
import { useMedia } from 'src/shared/hooks/useMedia';
import subFooterImg from 'src/static/images/sub-footer.png';
import content from 'src/content/home.json';
import { analytics } from 'src/utils/firebase';

export const SubFooter = ({
  body,
  btnText,
  to,
}: {
  body?: string;
  btnText?: string;
  to?: string;
}) => {
  const matches = useMedia();
  return (
    <STFlex
      flexDirection="column"
      bg={['#F2F8FE', 'transparent']}
      height={[280, 346]}
      mx={[4, 7]}
      my={[5, 5]}
      justifyContent="center"
      alignItems="center"
      borderRadius={30}
      px={[20, 150]}
      position="relative"
    >
      {matches.medium ? (
        <Box
          as="img"
          src={subFooterImg}
          height="100%"
          width="100%"
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
        />
      ) : null}
      <STFlex flexDirection="column" alignItems="center" zIndex={1}>
        <BaseText
          fontWeight={500}
          fontSize={[24, 40]}
          fontFamily="montserrat"
          textAlign="center"
          my={[20, 5]}
          color="#484848"
          width={['90%', '95%']}
        >
          {body || (
            <>
              When{' '}
              <Box as="span" color="#F5AC30" fontWeight="800">
                you
              </Box>{' '}
              buy big,{' '}
              <Box as="span" color="#F5AC30" fontWeight="800">
                you
              </Box>{' '}
              deserve something big in return
            </>
          )}
        </BaseText>
        <StyledLink
          onClick={() => {
            analytics.logEvent('button_click', {
              name: 'Sub footer button',
            });
          }}
          to={to || '/join'}
          mt={[4, 0]}
        >
          <STButton width={220} height={52} fontWeight={600}>
            {btnText || content.subFooter.button}
          </STButton>
        </StyledLink>
      </STFlex>
    </STFlex>
  );
};
